import React, { Component } from 'react';
import {
  useNavigate,
  useLocation,
  Link
} from 'react-router-dom';
import { withTranslation, Translation, } from 'react-i18next';
import i18n from "../../i18n";

import { View, Text, Image, ActivityIndicator} from "react-native-web";

import HamburgerMenu from 'react-hamburger-menu';

const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

export default function FooterTablet() {
  const currentYear = new Date().getFullYear();
   const navigate = useNavigate();

   const location = useLocation();

   let pathname = location.pathname;






    return (

       <div>

               <div style={{textAlign: 'center', color: '#fff', fontSize: '1.5rem'}}>{`Restez connecté(e) à la dynamique:`}</div>


               <div style={{clear: 'both', height: '10px'}}/>

               <div style={{textAlign: 'center', color: '#fff', fontSize: '1.3rem'}}>
                   <a href="/newsletter" style={{color:'#a7c7fa'}}>{`Abonnez-vous à notre newsletter`}</a>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;<a href="https://whatsapp.com/channel/0029VbApiLj6BIEa4sh5Z92F" target="_blank" style={{color:'#a7c7fa'}}>{`Rejoignez notre groupe WhatsApp`}</a>
               </div>

               <div style={{clear: 'both', height: '100px'}}/>


                <div style={{textShadow: '1px 1px 2px rgba(0, 0, 0,1)', fontSize: '17px'}}>
                  {i18n.language == 'en' &&
                     <div style={{textAlign: 'center', color: '#fff'}}>
                         {`< Re > RDC · v${global.version} ·`} · © {currentYear} · This website is powered by <a href="https://www.debyoo.com" target="_blank" style={{color: '#fff'}}>Debyoo</a>
                    </div>
                  }

                  {i18n.language == 'fr' &&
                     <div style={{textAlign: 'center', color: '#fff'}}>
                         {`< Re > RDC · v${global.version} ·`} © {currentYear} · Ce site est propulsé par <a href="https://www.debyoo.com" target="_blank" style={{color: '#fff'}}>Debyoo</a>
                    </div>
                  }
                </div>

                <div style={{clear: 'both', height: '40px'}}/>

        </div>

    )

}
